import React from "react";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Typography,
    Form,
    Col,
    Select,
    DatePicker,
    Divider,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { labelConfig } from "../../../../group.config";


//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";

const { Text, Title } = Typography;
const dateFormat = 'YYYY/MM/DD';

const TermsForm = (props) => {
    const {
        onFinish,
        dayData,
        onData,
        form,
        initialValues,
        interestTypeOptions,
        interestRateType,
        glimLoanProdDetails,
        loanTermTypeData,
        isRepaidEveryMonth,
    } = props;

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
            initialValues={initialValues}
        >
            <Row>
                <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                        {labelConfig.generalInfo}
                    </Title>
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.loanTerm}
                        name="loanTermFrequency"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.loanTerm),
                            },
                        ]}
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.loanTerm
                            )}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.loanTermType}
                        name="loanTermFrequencyType"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.loanTermType),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.loanTermType,
                                "select"
                            )}
                            options={loanTermTypeData}
                            showSearch
                        />
                    </Form.Item>
                </Col>
                <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                        {labelConfig.repaymentInfo}
                    </Title>
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.numberOfRepayments}
                        name="numberOfRepayments"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.numberOfRepayments),
                            },
                        ]}
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.numberOfRepayments,
                                "select"
                            )}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.repaidEvery}
                        name="repaymentEvery"
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(labelConfig.repaidEvery)}
                            disabled={
                                !glimLoanProdDetails?.product?.allowAttributeOverrides
                                    ?.repaymentEvery
                            }
                            className="of-bold-disable-input"
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.repaidEveryType}
                        name="repaymentFrequencyType"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.repaidEveryType),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.repaidEveryType,
                                "select"
                            )}
                            disabled={
                                !glimLoanProdDetails?.product?.allowAttributeOverrides
                                    ?.repaymentEvery
                            }
                            options={loanTermTypeData}
                            showSearch
                        />
                    </Form.Item>
                </Col>
                {isRepaidEveryMonth &&
                    <>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.on}
                                name="on"
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.on,
                                        "select"
                                    )}
                                    options={onData}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.day}
                                name="day"
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.day,
                                        "select"
                                    )}
                                    options={dayData}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                    </>
                }
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.firstRepaymentOn}
                        name="repaymentsStartingFromDate"
                    >
                        <DatePicker
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.firstRepaymentOn,
                                "select"
                            )}
                            style={{ width: "100%", height: 32.5 }}
                            format={dateFormat}
                        />
                    </Form.Item>
                </Col>
                <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                        {labelConfig.interestInfo}
                    </Title>
                </Divider>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.interestChargedFrom}
                        name="interestChargedFromDate"
                    >
                        <DatePicker
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.interestChargedFrom,
                                "select"
                            )}
                            style={{ width: "100%", height: 32.5 }}
                            format={dateFormat}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={`${labelConfig.nominalInterestRate}  ${interestRateType}`}
                        name="interestRatePerPeriod"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.nominalInterestRate),
                            },
                        ]}
                    >
                        <Input
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.nominalInterestRate
                            )}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.interestMethod}
                        name="interestType"
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.interestMethod,
                                "select"
                            )}
                            disabled={
                                !glimLoanProdDetails?.product?.allowAttributeOverrides
                                    ?.interestType
                            }
                            options={interestTypeOptions}
                            showSearch
                        />
                    </Form.Item>
                </Col>

            </Row>
        </Form>
    );
};

export default TermsForm;
